import { Referral } from "@/types";
import { Stack, Typography } from "@mui/material";
import { FC } from "react";
import { sanitizeFieldRestProps, useRecordContext } from "react-admin";
import { InvitesCountCellProps } from "./invites-count-cell.types";
import {
  CheckCircleOutline as SuccessIcon,
  Autorenew as PendingIcon,
  Block as RejectIcon,
} from "@mui/icons-material";
import { green, red, yellow } from "@mui/material/colors";

const InvitesCountCell: FC<InvitesCountCellProps> = ({
  referralRole,
  ...props
}) => {
  const referral = useRecordContext<Referral>();

  if (!referral) return null;

  const activeInvitesCount = referral.invitesCountByRole![referralRole].active;
  const inactiveInvitesCount =
    referral.invitesCountByRole![referralRole].inactive +
    referral.invitesCountByRole![referralRole]["not-finished-profile"] +
    referral.invitesCountByRole![referralRole]["not-onboarded"];
  const pendingInvites = referral.invitesCountByRole![referralRole].pending;

  return (
    <Stack
      direction={"row"}
      spacing={2}
      sx={{ cursor: "pointer" }}
      alignItems={"center"}
      {...sanitizeFieldRestProps(props)}
    >
      <Stack direction={"row"} spacing={0.5}>
        <SuccessIcon fontSize="small" sx={{ color: green[500] }} />
        <Typography variant="body2">{activeInvitesCount}</Typography>
      </Stack>

      <Stack direction={"row"} spacing={0.5}>
        <PendingIcon fontSize="small" sx={{ color: yellow[500] }} />
        <Typography variant="body2">{pendingInvites}</Typography>
      </Stack>

      <Stack direction={"row"} spacing={0.5}>
        <RejectIcon fontSize="small" sx={{ color: red[500] }} />
        <Typography variant="body2">{inactiveInvitesCount}</Typography>
      </Stack>
    </Stack>
  );
};

export { InvitesCountCell };
